(function regionMap($, Drupal) {
  Drupal.behaviors.rmap = {
    attach(context) {
      const setRegionState = (target, action) => {
        const regionName = $(target).attr('id');
        const regionClass = `.interactive-map__region--${regionName}`;

        if (action === 'add') {
          $(regionClass).addClass('active');
        }
        else {
          $(regionClass).removeClass('active');
        }
      };

      $('.interactive-map__key-link', context).hover((e) => {
        setRegionState(e.target, 'add');
      }, (e) => {
        setRegionState(e.target, 'remove');
      });
    },
  };
}(jQuery, Drupal));
